var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.attributes)?_c('div',_vm._l((_vm.visibleAttributes),function(attribute){return _c('SfProperty',{key:attribute,staticClass:"m-b-5",attrs:{"name":_vm.$t(attribute),"value":_vm.$t(_vm.attributes[attribute].join(', '))}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }